/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["div.row[_ngcontent-%COMP%] {\n  max-height: 800px;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvcGFnZXMvcmVjZWlwdC1tb2RlcmF0ZS1jb21wYXJlL3JlY2VpcHQtbW9kZXJhdGUtY29tcGFyZS5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsaUJBQWlCO0FBQ25CIiwiZmlsZSI6InNyYy9hcHAvcGFnZXMvcmVjZWlwdC1tb2RlcmF0ZS1jb21wYXJlL3JlY2VpcHQtbW9kZXJhdGUtY29tcGFyZS5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiZGl2LnJvdyB7XG4gIG1heC1oZWlnaHQ6IDgwMHB4O1xufVxuIl19 */"];
export { styles as styles };
